import React, { useState, useEffect } from 'react';

const modalStyles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1000,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  modal: {
    background: 'white', padding: '20px', borderRadius: '8px',
    width: '90%', maxWidth: '560px', maxHeight: '85vh', overflowY: 'auto',
  },
  formGroup: { marginBottom: '12px' },
  label: { display: 'block', marginBottom: '4px', fontWeight: 'bold', fontSize: '0.9rem' },
  input: { width: '100%', padding: '8px', boxSizing: 'border-box', fontSize: '0.9rem' },
  select: { width: '100%', padding: '8px', boxSizing: 'border-box', fontSize: '0.9rem' },
  buttons: { display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' },
  saveButton: { backgroundColor: '#007bff', color: 'white', padding: '8px 16px', cursor: 'pointer', border: 'none', borderRadius: '5px' },
  cancelButton: { backgroundColor: '#6c757d', color: 'white', padding: '8px 16px', cursor: 'pointer', border: 'none', borderRadius: '5px' },
  hint: { marginTop: '4px', fontSize: '0.8rem', color: '#6c757d', lineHeight: 1.4 },
};

const JOB_DUTY_HINT = '노인일자리 참여자는 근무직무 9번(단순노무직무)으로 등록해 주세요.';

const toYyyyMmDd = (v) => {
  if (!v) return '';
  const s = String(v).trim();
  const m = s.match(/(\d{4})-?(\d{2})-?(\d{2})/);
  if (m) return `${m[1]}${m[2]}${m[3]}`;
  return s.replace(/\D/g, '').slice(0, 8);
};

const formatDisplay = (v) => {
  if (!v) return '';
  const s = String(v);
  if (s.length >= 8) return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`;
  return s;
};

const EditDisabledWorkerModal = ({
  row,
  isOpen,
  onClose,
  onSave,
  disabilityRecognitionOptions,
  disabilityTypeOptions,
  severityOptions,
  jobDutyOptions,
}) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (row) {
      setFormData({
        disabilityRecognitionType: row.disabilityRecognitionType || '',
        disabilityType: row.disabilityType || '',
        injuryGrade: row.injuryGrade || '',
        severityStatus: row.severityStatus || '',
        disabilityRecognitionDate: formatDisplay(row.disabilityRecognitionDate),
        jobDuty: row.jobDuty || '9',
      });
    }
  }, [row]);

  if (!isOpen || !row) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      disabilityRecognitionType: formData.disabilityRecognitionType || null,
      disabilityType: formData.disabilityType || null,
      injuryGrade: formData.injuryGrade || null,
      severityStatus: formData.severityStatus || null,
      disabilityRecognitionDate: toYyyyMmDd(formData.disabilityRecognitionDate) || null,
      jobDuty: formData.jobDuty || null,
    };
    onSave(row.participantId, payload);
  };

  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <h3>장애인 정보 수정 - {row.name}</h3>
        <form onSubmit={handleSubmit}>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>장애인정구분</label>
            <select name="disabilityRecognitionType" style={modalStyles.select} value={formData.disabilityRecognitionType} onChange={handleChange}>
              <option value="">-- 선택 --</option>
              {disabilityRecognitionOptions.map((o) => (
                <option key={o.value} value={o.value}>{o.value}({o.label})</option>
              ))}
            </select>
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>장애유형</label>
            <select name="disabilityType" style={modalStyles.select} value={formData.disabilityType} onChange={handleChange}>
              <option value="">-- 선택 --</option>
              {disabilityTypeOptions.map((o) => (
                <option key={o.value} value={o.value}>{o.value}({o.label})</option>
              ))}
            </select>
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>상이등급</label>
            <input type="text" name="injuryGrade" style={modalStyles.input} value={formData.injuryGrade || ''} onChange={handleChange} placeholder="국가유공자만" />
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>중증(경증) 여부</label>
            <select name="severityStatus" style={modalStyles.select} value={formData.severityStatus} onChange={handleChange}>
              <option value="">-- 선택 --</option>
              {severityOptions.map((o) => (
                <option key={o.value} value={o.value}>{o.value}({o.label})</option>
              ))}
            </select>
          </div>
          {row.severeDoubleCountEligible && (
            <div style={modalStyles.formGroup}>
              <label style={modalStyles.label}>중증 2배수 인정 (자동계산)</label>
              <div style={{ padding: '8px', background: '#f5f5f5', borderRadius: '4px', fontSize: '0.9rem' }}>
                {row.severeDoubleCountEligible}
              </div>
            </div>
          )}
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>장애인정일 (YYYYMMDD)</label>
            <input type="text" name="disabilityRecognitionDate" style={modalStyles.input} value={formData.disabilityRecognitionDate || ''} onChange={handleChange} placeholder="예: 20120101" maxLength={10} />
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>입사일 (참여자 명단 연동)</label>
            <div style={{ padding: '8px', background: '#f5f5f5', borderRadius: '4px', fontSize: '0.9rem' }}>
              {formatDisplay(row.employmentStartDate) || '-'}
            </div>
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>퇴사일 (참여자 명단 연동)</label>
            <div style={{ padding: '8px', background: '#f5f5f5', borderRadius: '4px', fontSize: '0.9rem' }}>
              {formatDisplay(row.employmentEndDate) || '-'}
            </div>
          </div>
          <div style={modalStyles.formGroup}>
            <label style={modalStyles.label}>근무 직무</label>
            <select
              name="jobDuty"
              style={modalStyles.select}
              value={formData.jobDuty}
              onChange={handleChange}
              title={JOB_DUTY_HINT}
            >
              <option value="">-- 선택 --</option>
              {jobDutyOptions.map((o) => (
                <option key={o.value} value={o.value}>{o.value}({o.label})</option>
              ))}
            </select>
            <p style={modalStyles.hint}>{JOB_DUTY_HINT}</p>
          </div>
          <div style={modalStyles.buttons}>
            <button type="button" style={modalStyles.cancelButton} onClick={onClose}>
              취소
            </button>
            <button type="submit" style={modalStyles.saveButton}>
              저장
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditDisabledWorkerModal;
